/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Edição feita',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Fazer edições',
  'editor-common-extensibility.macro.button.configure': 'Configurar {macroName}',
  'editor.extension.legacyContentHeader': 'Conteúdo herdado',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'Este conteúdo tem funcionalidade limitada,',
  'editor.extension.legacyContentHeader.learnMore': 'Saiba mais',
  'editor.trackChanges.toolbarIconLabel': 'Acompanhar alterações',
  'fablric.editor.viewAllInserts': 'Exibir todas as inserções',
  'fabric.editor.action': 'Item de ação',
  'fabric.editor.action.description': 'Criar e atribuir itens de ação',
  'fabric.editor.addAltText': 'Texto alt',
  'fabric.editor.addColumnLeft': 'Adicionar coluna à esquerda',
  'fabric.editor.addColumnRight': 'Adicionar coluna à direita',
  'fabric.editor.addCommentOnMedia': 'Adicionar comentário',
  'fabric.editor.addImageBorder': 'Adicionar borda',
  'fabric.editor.addLoomVideo': 'Gravar vídeo do Loom',
  'fabric.editor.addLoomVideoComment': 'Grave um comentário em vídeo do Loom',
  'fabric.editor.addMediaFiles': 'Adicionar imagem, vídeo ou arquivo',
  'fabric.editor.addRowAbove': 'Adicionar linha acima',
  'fabric.editor.addRowBelow': 'Adicionar linha abaixo',
  'fabric.editor.addUpdatedAltText': 'Adicionar texto alternativo',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Use o Atlassian Intelligence para encontrar item de ação e mostrar os itens em um painel',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Painel de item de ação (Beta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Use o Atlassian Intelligence para resumir esta página e mostrar o resumo em um painel',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Painel de resumo da página (Beta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Conteúdo selecionado',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Gera conteúdo para ser inserido na atualização',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Resume o conteúdo da atualização',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Gerar',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Pergunte ao Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': 'Editar',
  'fabric.editor.ai.config.item.action.insert': 'Inserir',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Inserir na parte superior',
  'fabric.editor.ai.config.item.action.insertBelow': 'Inserir na parte inferior',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': 'Insira abaixo do original',
  'fabric.editor.ai.config.item.action.replace': 'Substituir',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Substituir título',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'O título não pode exceder {maxLength} caracteres',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'Continue no chat',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Abrir no bate-papo',
  'fabric.editor.ai.config.item.addPolish.description': 'Aprimora o conteúdo para refinar',
  'fabric.editor.ai.config.item.addPolish.title': 'Refinar',
  'fabric.editor.ai.config.item.agent.title': 'Agente Rovo do Atlassian Intelligence',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Reduz o conteúdo para que ele fique mais conciso',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Encurtar atualização',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Cria uma descrição de pull request com um resumo das alterações',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Criar descrição da pull request',
  'fabric.editor.ai.config.item.brainstorm.description': 'Gera uma lista de ideias para o tópico que você quiser',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Diga o assunto...',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Fazer brainstorming',
  'fabric.editor.ai.config.item.brainstorm.title': 'Fazer brainstorming',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': 'Comprimento',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': 'Ajustar o comprimento',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Altera o tom do conteúdo para casual',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Casual',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Casual',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Mudar o tom para casual',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Altera o tom do conteúdo para educacional',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Educativo',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Educativo',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Mudar o tom para educacional',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description':
    'Altera o tom do conteúdo para demonstrar empatia',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empático',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empático',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Mudar o tom para empático',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Alterar tom para...',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Altera o tom do conteúdo para neutro',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutro',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutro',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Mudar o tom para neutro',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description': 'Altera o tom do conteúdo para profissional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Profissional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Profissional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Mudar o tom para profissional',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Reformata o conteúdo em uma lista de marcadores',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Converter em lista de marcadores',
  'fabric.editor.ai.config.item.convertToTable.description': 'Reformata o conteúdo em uma tabela com cabeçalhos',
  'fabric.editor.ai.config.item.convertToTable.title': 'Converter em tabela',
  'fabric.editor.ai.config.item.draftReply.description':
    'Elabora uma resposta com base em itens similares ao que você está trabalhando',
  'fabric.editor.ai.config.item.draftReply.title': 'Elaborar resposta',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Corrige erros ortográficos e gramaticais',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Gramática e ortografia',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Corrigir gramática e ortografia',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Melhora a clareza, a estrutura e o tom para gerar mais engajamento e facilitar a compreensão',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Melhorar a escrita',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Melhorar a escrita',
  'fabric.editor.ai.config.item.findActionItems.description': 'Encontra itens de ação no conteúdo que você inserir',
  'fabric.editor.ai.config.item.findActionItems.title': 'Encontrar itens de ação',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Selecione abaixo (a geração gratuita está desativada no Elevate no momento)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Escrever com IA ou selecionar abaixo',
  'fabric.editor.ai.config.item.generateContent.rovoPromptHint': 'Escreva com o Rovo ou selecione abaixo',
  'fabric.editor.ai.config.item.generateEscalationNotes.description':
    'Gera notas de escalonamento com base no contexto do item',
  'fabric.editor.ai.config.item.generateEscalationNotes.title': 'Gere notas de escalonamento',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Reestruture a descrição do item com base no tipo de item',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Melhorar descrição',
  'fabric.editor.ai.config.item.makeLonger.description': 'Expande o conteúdo com base no contexto apresentado',
  'fabric.editor.ai.config.item.makeLonger.title': 'Expandir',
  'fabric.editor.ai.config.item.range.agent.description': 'Sem descrição',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    'Diga ao agente para escrever algo ou escolha uma das opções abaixo',
  'fabric.editor.ai.config.item.rephrase.description': 'Cria uma sugestão para reescrever suas frases',
  'fabric.editor.ai.config.item.rephrase.title': 'Reformular',
  'fabric.editor.ai.config.item.shorten.description': 'Reduz o conteúdo para que ele fique mais conciso',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Encurtar',
  'fabric.editor.ai.config.item.shorten.title': 'Encurtar',
  'fabric.editor.ai.config.item.suggest.description': 'Sugere um título para o conteúdo que você inserir',
  'fabric.editor.ai.config.item.suggest.title': 'Sugerir um título',
  'fabric.editor.ai.config.item.summarize.description':
    'Resume o texto em que você está trabalhando, destacando os pontos principais',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Resumir texto',
  'fabric.editor.ai.config.item.summarize.title': 'Resumir texto',
  'fabric.editor.ai.config.item.translate.czech': 'Checo',
  'fabric.editor.ai.config.item.translate.danish': 'Dinamarquês',
  'fabric.editor.ai.config.item.translate.dutch': 'Holandês',
  'fabric.editor.ai.config.item.translate.english': 'Inglês',
  'fabric.editor.ai.config.item.translate.finnish': 'Finlandês',
  'fabric.editor.ai.config.item.translate.french': 'Francês',
  'fabric.editor.ai.config.item.translate.german': 'Alemão',
  'fabric.editor.ai.config.item.translate.italian': 'Italiano',
  'fabric.editor.ai.config.item.translate.japanese': 'Japonês',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Traduzir',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Traduzir para...',
  'fabric.editor.ai.config.item.translate.norwegian': 'Norueguês',
  'fabric.editor.ai.config.item.translate.russian': 'Russo',
  'fabric.editor.ai.config.item.translate.spanish': 'Espanhol',
  'fabric.editor.ai.config.item.translate.swedish': 'Sueco',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Traduz o texto do trabalho atual para o chinês (simplificado)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Traduzir para chinês (simplificado)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Traduz o texto do trabalho atual para o chinês (tradicional)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Traduzir para chinês (tradicional)',
  'fabric.editor.ai.config.item.translateTo.czech.description': 'Traduz o texto do trabalho atual para o tcheco',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Traduzir para tcheco',
  'fabric.editor.ai.config.item.translateTo.danish.description': 'Traduz o texto do trabalho atual para o dinamarquês',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Traduzir para dinamarquês',
  'fabric.editor.ai.config.item.translateTo.dutch.description': 'Traduz o texto do trabalho atual para o holandês',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Traduzir para holandês',
  'fabric.editor.ai.config.item.translateTo.english.description': 'Traduz o texto do trabalho atual para o inglês',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Traduzir para inglês',
  'fabric.editor.ai.config.item.translateTo.finnish.description': 'Traduz o texto do trabalho atual para o finlandês',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Traduzir para finlandês',
  'fabric.editor.ai.config.item.translateTo.french.description': 'Traduz o texto do trabalho atual para o francês',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Traduzir para francês',
  'fabric.editor.ai.config.item.translateTo.german.description': 'Traduz o texto do trabalho atual para o alemão',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Traduzir para alemão',
  'fabric.editor.ai.config.item.translateTo.hungarian.description': 'Traduz o texto do trabalho atual para o húngaro',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Traduzir para húngaro',
  'fabric.editor.ai.config.item.translateTo.italian.description': 'Traduz o texto do trabalho atual para o italiano',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Traduzir para italiano',
  'fabric.editor.ai.config.item.translateTo.japanese.description': 'Traduz o texto do trabalho atual para o japonês',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Traduzir para japonês',
  'fabric.editor.ai.config.item.translateTo.korean.description': 'Traduz o texto do trabalho atual para o coreano',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Traduzir para coreano',
  'fabric.editor.ai.config.item.translateTo.norwegian.description': 'Traduz o texto do trabalho atual para o norueguês',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Traduzir para norueguês',
  'fabric.editor.ai.config.item.translateTo.polish.description': 'Traduz o texto do trabalho atual para o polonês',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Traduzir para polonês',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Traduz o texto do trabalho atual para o português (BR)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Traduzir para português (BR)',
  'fabric.editor.ai.config.item.translateTo.russian.description': 'Traduz o texto do trabalho atual para o russo',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Traduzir para russo',
  'fabric.editor.ai.config.item.translateTo.spanish.description':
    'Traduz o texto que você está trabalhando para o espanhol',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Traduzir para espanhol',
  'fabric.editor.ai.config.item.translateTo.swedish.description': 'Traduz o texto do trabalho atual para o sueco',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Traduzir para sueco',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Traduz o texto do trabalho atual para o tailandês',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Traduzir para tailandês',
  'fabric.editor.ai.config.item.translateTo.turkish.description': 'Traduz o texto do trabalho atual para o turco',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Traduzir para turco',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description': 'Traduz o texto do trabalho atual para o ucraniano',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Traduzir para ucraniano',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Traduz o texto do trabalho atual para o vietnamita',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Traduzir para vietnamita',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Mudar o tom',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Reescrever',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Traduzir',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Título da página',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Página',
  'fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage':
    'Ocorreu um erro e não foi possível gerar uma resposta no momento. Tente de novo mais tarde.',
  'fabric.editor.ai.experience-application.documentInsertError':
    'A gente está com problemas para inserir a resposta. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'A gente está com problemas para gerar a prévia. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'A gente recebeu muitas solicitações recentes para o Atlassian Intelligence (AI). Tente de novo em alguns minutos ou leia sobre o <link>uso excessivo do AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Não foi possível obter uma resposta. A solicitação ou resposta estava acima do limite dessa solicitação. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'A gente está com problemas. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.experience.adfStreamingError': 'A gente pede desculpas. Não foi possível obter a resposta.',
  'fabric.editor.ai.experience.aifcAdfStreamingError': 'A gente pede desculpas. Não foi possível obter a resposta.',
  'fabric.editor.ai.experience.aifcApiError': 'Ocorreu um erro desconhecido.',
  'fabric.editor.ai.experience.aifcApiErrorRetry': 'Ocorreu um erro desconhecido. Recarregue e tente de novo.',
  'fabric.editor.ai.experience.aifcAupViolationMessage':
    'O conteúdo não está em conformidade com nossa <link>Política de Uso Aceitável</link>.',
  'fabric.editor.ai.experience.aifcHipaaContentError':
    'O conteúdo contém links para conteúdo restrito da HIPAA. Remova os links e tente de novo.',
  'fabric.editor.ai.experience.aifcInputTooShortError':
    'É necessário mais conteúdo para concluir a solicitação. Selecione mais conteúdo e tente de novo.',
  'fabric.editor.ai.experience.aifcInternalServerError':
    'A gente pede desculpas. Não foi possível obter a resposta. Tente de novo em 5 minutos ou <link>verifique o status do Rovo</link>.',
  'fabric.editor.ai.experience.aifcRateLimitEnforced':
    'Você atingiu o <link>número máximo de solicitações</link>. Tente de novo em 5 minutos.',
  'fabric.editor.ai.experience.aifcTokenLimitExceeded':
    'Há muito conteúdo para processar. Selecione menos conteúdo e tente de novo.',
  'fabric.editor.ai.experience.apiError': 'Não foi possível obter uma resposta. Tente de novo.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'O prompt ou conteúdo pode não estar em conformidade com a Política de uso aceitável da Atlassian. Revise e consulte a <link>Política de uso aceitável</link> da empresa, se necessário. Se o problema persistir, considere tentar outro prompt ou conteúdo.',
  'fabric.editor.ai.experience.browseMore.agents': 'Pesquisar agentes',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Quer descartar a entrada?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Quer descartar a resposta?',
  'fabric.editor.ai.experience.discardStreamingInDocumennt': 'Cancelar solicitação e descartar a resposta?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError':
    'A geração gratuita está desativada no Elevate no momento.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Agora é possível colar links 🔗 no conteúdo do Jira e do Confluence em seus prompts.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Com tecnologia Rovo',
  'fabric.editor.ai.experience.generatingAiResponse': 'Gerando',
  'fabric.editor.ai.experience.hipaaContentError':
    'O Atlassian Intelligence não conseguiu processar a solicitação, pois o conteúdo contém links para conteúdo restrito da HIPAA. Remova esses links e tente de novo.',
  'fabric.editor.ai.experience.inputTooShortError':
    'O conteúdo é curto demais para ser resumido. Adicione mais e tente de novo.',
  'fabric.editor.ai.experience.internalServerError':
    'O Atlassian Intelligence (AI) não está respondendo. Tente de novo mais tarde ou <link>confira o status do AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Gerando',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analisando: revisando a pergunta.',
  'fabric.editor.ai.experience.messageTemplateContentSearch':
    'Pesquisando: um momento enquanto a gente pesquisa informações.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask':
    'Pesquisando: um momento enquanto a gente pesquisa no Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration':
    'Pesquisando: um momento enquanto a gente pesquisa na página.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Sem resultados',
  'fabric.editor.ai.experience.noTextualContentError':
    'É necessário mais conteúdo para concluir a solicitação. Selecione mais conteúdo e tente de novo.',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'O Atlassian Intelligence não tem sugestões no momento. Use um prompt ou conteúdo diferente.',
  'fabric.editor.ai.experience.showMoreButton': 'Ver mais',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Ações',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agentes',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Fonte de conhecimento',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Agentes Rovo',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Agentes Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Use um agente Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Usar conhecimento geral',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Usar conhecimento da organização',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'A gente está com problemas para gerar a pré-visualização. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    'A gente está com problemas. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Inserir na parte inferior',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Substituir',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'As solicitações de geração de conteúdo que fazem referência a URLs estão em beta.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Destaque um termo, um acrônimo ou uma abreviatura',
  'fabric.editor.ai.selectionToolbar.define.title': 'Definir',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.DefineDropdownIconTitle.title': 'Definir',
  'fabric.editor.ai.toolbar.askAI.title': 'Perguntar ao Atlassian Intelligence',
  'fabric.editor.ai.toolbar.askRovo.title': 'Pergunte ao Rovo',
  'fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand': "Pergunte ao Rovo {key}+'",
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': 'Pergunte à IA do Rovo',
  'fabric.editor.ai.toolbar.changeTone.title': 'Alterar o tom',
  'fabric.editor.ai.toolbar.changeToneOptions.title': 'Alterar as opções de tom',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Melhorar a escrita',
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    'Peça ao Atlassian Intelligence que melhore a redação do texto selecionado',
  'fabric.editor.ai.toolbar.makeLonger.title': 'Expandir',
  'fabric.editor.ai.toolbar.makeShorter.title': 'Encurtar',
  'fabric.editor.ai.toolbar.moreCasualTone.title': 'Mais casual',
  'fabric.editor.ai.toolbar.moreEmpatheticTone.title': 'Mais empático',
  'fabric.editor.ai.toolbar.moreProfessionalTone.title': 'Mais profissional',
  'fabric.editor.ai.toolbar.moreRovoOptions.label': 'Mais opções do Rovo',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.spellingAndGrammar.title': 'Corrigir ortografia e gramática',
  'fabric.editor.ai.toolbar.summarize.title': 'Resumir',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.translate.title': 'Traduzir',
  'fabric.editor.ai.toolbar.translateOptions.label': 'Traduzir opções',
  'fabric.editor.ai.toolbar.tryAI.title': 'Teste o AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Abrir o Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "Pergunte ao AI {key}+'",
  'fabric.editor.alignCenter': 'Alinhar ao centro',
  'fabric.editor.alignImageCenter': 'Alinhar ao centro',
  'fabric.editor.alignImageLeft': 'Alinhar à esquerda',
  'fabric.editor.alignImageRight': 'Alinhar à direita',
  'fabric.editor.alignLeft': 'Alinhar à esquerda',
  'fabric.editor.alignRight': 'Alinhar à direita',
  'fabric.editor.alignTableCenter': 'Alinhar ao centro',
  'fabric.editor.alignTableLeft': 'Alinhar à esquerda',
  'fabric.editor.alignment': 'Alinhamento do texto',
  'fabric.editor.altText': 'Texto Alt',
  'fabric.editor.alttext.validation': 'Remova todos os caracteres especiais em texto alt.',
  'fabric.editor.annotationToolbar': 'Barra de ferramentas de anotação',
  'fabric.editor.backLink': 'Voltar',
  'fabric.editor.backgroundColor': 'Cor do plano de fundo',
  'fabric.editor.block.menu.codeblock': 'Bloco de código',
  'fabric.editor.block.menu.copy.block': 'Copiar bloco',
  'fabric.editor.block.menu.copy.content': 'Copiar conteúdo',
  'fabric.editor.block.menu.copy.link': 'Copiar link',
  'fabric.editor.block.menu.copy.link.to.block': 'Copie o link para bloquear',
  'fabric.editor.block.menu.delete.block': 'Excluir',
  'fabric.editor.block.menu.layout': 'Layout',
  'fabric.editor.block.menu.move.down': 'Mover para baixo',
  'fabric.editor.block.menu.move.up': 'Mover para cima',
  'fabric.editor.block.menu.paragraph': 'Parágrafo',
  'fabric.editor.block.menu.turn.into': 'Transformar em',
  'fabric.editor.blockCardUnavailable': 'O link em linha está em {node}, e sua exibição não pode ser alterada',
  'fabric.editor.blockControlDelete': 'Excluir',
  'fabric.editor.blockControlDragHandleMove': 'Arraste para mover',
  'fabric.editor.blockControlDragHandleMoveOrOpen': 'Arraste para mover {br} Clique para abrir o menu',
  'fabric.editor.blockControlDragHandleRearrange': 'Arraste para reorganizar',
  'fabric.editor.blockControlInsert': 'Inserir',
  'fabric.editor.blockControlMoveDown': 'Mover para baixo',
  'fabric.editor.blockControlMoveLeft': 'Mover para esquerda',
  'fabric.editor.blockControlMoveRight': 'Mover para direita',
  'fabric.editor.blockControlMoveUp': 'Mover para cima',
  'fabric.editor.blockControlMovedDown': 'O conteúdo foi movido para baixo',
  'fabric.editor.blockControlMovedUp': 'O conteúdo foi movido para cima',
  'fabric.editor.blockDescription': 'Mostrar mais informações sobre links, incluindo resumo e ações',
  'fabric.editor.blockTitle': 'Cartão',
  'fabric.editor.blockquote': 'citação',
  'fabric.editor.blockquote.description': 'Inserir cotação ou citação',
  'fabric.editor.blockquote2': 'Citar',
  'fabric.editor.bold': 'Negrito',
  'fabric.editor.breakout.resizeCodeBlock': 'Redimensionar trecho de código',
  'fabric.editor.breakout.resizeElement': 'Redimensionar elemento',
  'fabric.editor.breakout.resizeExpand': 'Redimensionar a opção Expandir',
  'fabric.editor.breakout.resizeLayout': 'Redimensionar layout',
  'fabric.editor.breakoutFullWidthLabel': 'Largura total',
  'fabric.editor.breakoutWideWidthLabel': 'Largo',
  'fabric.editor.bug': 'Bug',
  'fabric.editor.bulletedList': 'Lista com marcadores',
  'fabric.editor.canNotSortTable': '⚠️ Você não pode ordenar uma tabela com células mescladas',
  'fabric.editor.cancelButton': 'Cancelar',
  'fabric.editor.captionPlaceholder': 'Adicionar legenda',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt':
    'Adicione uma legenda: clique duas vezes para pré-visualizar',
  'fabric.editor.cardFloatingControls': 'Opções de cartão',
  'fabric.editor.cellBackground': 'Plano de fundo da célula',
  'fabric.editor.cellOptions': 'Opções de célula',
  'fabric.editor.checkUncheckActionItem': 'Alternar item de ação',
  'fabric.editor.clearAltTextEdit': 'Apagar texto alt',
  'fabric.editor.clearCells': '{0, plural, one {Limpar célula} other {Limpar células}}',
  'fabric.editor.clearFormatting': 'Limpar formatação',
  'fabric.editor.clearLink': 'Limpar link',
  'fabric.editor.clearLinkText': 'Limpar texto',
  'fabric.editor.closeAltTextEdit': 'Voltar',
  'fabric.editor.closeFindReplaceDialog': 'Fechar',
  'fabric.editor.closeHelpDialog': 'Fechar caixa de diálogo de ajuda',
  'fabric.editor.code': 'Código',
  'fabric.editor.code.on': '{textFormattingOff}, código ativado',
  'fabric.editor.codeBidiWarningLabel':
    'Caracteres bidirecionais alteram a ordem em que o texto é renderizado. Eles podem ser usados para ocultar códigos mal-intencionados.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Copiado!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Copiar como texto',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Desligar agrupamento',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Ligar agrupamento',
  'fabric.editor.codeblock': 'Trecho de código',
  'fabric.editor.codeblock.description': 'Exibir código com destaque à sintaxe',
  'fabric.editor.collapseNode': 'Recolher conteúdo',
  'fabric.editor.collapseTable': 'Recolher tabela',
  'fabric.editor.colorPicker.menuLabel': 'Menu de seleção de cores',
  'fabric.editor.columnDragHandle': 'Opções de coluna',
  'fabric.editor.columnMovedLeft': 'Coluna movida para a esquerda para {index} de {total}',
  'fabric.editor.columnMovedRight': 'Coluna movida para a direita para {index} de {total}',
  'fabric.editor.columnSelected': 'Coluna {index} de {total} selecionada',
  'fabric.editor.columns': 'Layouts',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Insira {numberOfColumns} coluna igual} other {Insira {numberOfColumns} colunas iguais}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Inserir layout com coluna única',
  'fabric.editor.columns.description': 'Estruturar sua página usando seções',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Uma coluna foi inserida} other {{count} colunas foram inseridas}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Uma coluna foi removida} other {{count} colunas foram removidas}}',
  'fabric.editor.configFailedToLoad': 'Falha ao carregar',
  'fabric.editor.configPanel.cancel': 'Cancelar',
  'fabric.editor.configPanel.close': 'Fechar',
  'fabric.editor.configPanel.customSelect.createOption': 'Criar',
  'fabric.editor.configPanel.dateRange.custom.from': 'De',
  'fabric.editor.configPanel.dateRange.custom.to': 'Até',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Recolher',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Expandir',
  'fabric.editor.configPanel.dateRange.option.custom': 'Personalizado',
  'fabric.editor.configPanel.documentation': 'Documentação',
  'fabric.editor.configPanel.errorBoundary.note':
    'A gente informou a equipe. Você ainda pode editar e publicar esta página ou verificar o console de erros para obter mais informações.',
  'fabric.editor.configPanel.errorBoundary.title': 'Algo deu errado.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Não é possível combinar isMultiple com estilo: rádio',
  'fabric.editor.configPanel.formType.addField': 'Adicionar campo',
  'fabric.editor.configPanel.formType.removeField': 'Remover campo',
  'fabric.editor.configPanel.help': 'Precisa de ajuda?',
  'fabric.editor.configPanel.invalid': 'Campo inválido',
  'fabric.editor.configPanel.required': 'Campo obrigatório',
  'fabric.editor.configPanel.submit': 'Enviar',
  'fabric.editor.contextPanel.panelLabel': 'Painel de contexto',
  'fabric.editor.copiedToClipboard': 'Copiado!',
  'fabric.editor.copySyncBlock': 'Copiar',
  'fabric.editor.copySyncBlockTooltip': 'Copiar referência na área de transferência',
  'fabric.editor.copyToClipboard': 'Copiar',
  'fabric.editor.cornerControl': 'Destacar tabela',
  'fabric.editor.createComment': 'Comentar',
  'fabric.editor.createCommentDisabled':
    'Você só pode comentar em textos, títulos, emojis, datas, menções, links e status.',
  'fabric.editor.createCommentInvalid': 'Você só pode comentar em texto e cabeçalhos',
  'fabric.editor.customPanel': 'Painel personalizado',
  'fabric.editor.customPanel.description': 'Adicione uma observação com um emoji e plano de fundo colorido',
  'fabric.editor.datasource.assetsObjects.description':
    'Insira objetos a partir de Recursos no Jira Service Management com ferramentas de pesquisa e filtro',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Recursos',
  'fabric.editor.datasource.confluenceSearch': 'Inserir lista do Confluence',
  'fabric.editor.datasource.confluenceSearch.description':
    'Insira uma lista de resultados de pesquisa do Confluence com pesquisa, filtragem e configuração aprimoradas.',
  'fabric.editor.datasource.jiraIssue': 'Itens do Jira',
  'fabric.editor.datasource.jiraIssue.description':
    'Insira itens do Jira a partir do Jira Cloud com ferramentas aprimoradas de pesquisa, filtro e configuração.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Insira tickets do Jira a partir do Jira Cloud com ferramentas aprimoradas de pesquisa, filtro e configuração.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Tickets do Jira',
  'fabric.editor.datasourceAppearanceTitle': 'Lista',
  'fabric.editor.datasourceTitle': 'Editar consulta de pesquisa',
  'fabric.editor.date': 'Data',
  'fabric.editor.date.description': 'Adicionar data usando um calendário',
  'fabric.editor.datePickerOpenedAlert': 'O pop-up do editor de data foi aberto, pressione Tab para acessar',
  'fabric.editor.decision': 'Decisão',
  'fabric.editor.decision.description': 'Registre decisões para facilitar o acompanhamento',
  'fabric.editor.decisionPlaceholder': 'Adicionar uma decisão...',
  'fabric.editor.decreaseElementSize': 'Diminuir o tamanho do elemento',
  'fabric.editor.decreaseSize': 'Diminuir tamanho da tabela ou imagem',
  'fabric.editor.defaultAltText': 'Documento',
  'fabric.editor.delete': 'Excluir',
  'fabric.editor.description': 'Descrição',
  'fabric.editor.displayBlock': 'Mostrar cartão',
  'fabric.editor.displayEmbed': 'Mostrar incorporado',
  'fabric.editor.displayInline': 'Mostrar em linha',
  'fabric.editor.displayLink': 'Mostrar como texto',
  'fabric.editor.displayOptionUnavailableInParentNode': 'Esta opção de exibição não está disponível em {node}',
  'fabric.editor.displayText': 'Texto a ser exibido',
  'fabric.editor.distributeColumns': 'Distribuir colunas',
  'fabric.editor.dragHandleZone': 'Ativar a zona da alça de arraste',
  'fabric.editor.dropPlaceholderLabel': 'Documento',
  'fabric.editor.ecombedDescription': 'Mostrar visualização interativa de links',
  'fabric.editor.edit': 'Editar',
  'fabric.editor.edit.datasource': 'Editar consulta de pesquisa',
  'fabric.editor.edit.searchInput': 'Adicionar link',
  'fabric.editor.editAccessTitle': 'Você precisa ter acesso de edição',
  'fabric.editor.editAltText': 'Editar texto alt',
  'fabric.editor.editDatasourceStandalone': 'Editar',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Editar consulta de pesquisa',
  'fabric.editor.editDateText': 'Editar data',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Editar consulta de pesquisa',
  'fabric.editor.editDropdownEditLinkTitle': 'Editar link',
  'fabric.editor.editDropdownExpandIconLabel': 'Expandir menu suspenso',
  'fabric.editor.editDropdownTriggerTitle': 'Editar',
  'fabric.editor.editLink': 'Editar link',
  'fabric.editor.editMode.inviteToEditButton.title': 'Convidar para editar',
  'fabric.editor.editSourceLabel': 'Editar fonte',
  'fabric.editor.editSourceTooltip': 'Navegue até a página de origem do bloco de sincronização',
  'fabric.editor.editStatusColor': 'Editar cor do status',
  'fabric.editor.editStatusText': 'Editar status',
  'fabric.editor.editableContentLabel': 'Conteúdo editável',
  'fabric.editor.editorHelp': 'Ajuda do editor',
  'fabric.editor.editors': 'Editores',
  'fabric.editor.elementBrowser.help': 'Ajuda',
  'fabric.editor.elementInsertSidePanel.title': 'Inserir',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administração',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Todos',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Comunicação',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Conteúdo do Confluence',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Desenvolvimento',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Conteúdo externo',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formatação',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Mídia',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navegação',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Relatórios',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Imagens e efeitos visuais',
  'fabric.editor.elementbrowser.featured.whiteboard.description':
    'Use um quadro branco para adicionar recursos visuais à página',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Não há resultados para a pesquisa',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Pesquise com um termo diferente ou descubra apps novos para produtos Atlassian.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Explorar Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Nada corresponde à pesquisa.} one {{count} sugestão disponível por padrão.} other {{count} sugestões disponíveis por padrão.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Nada corresponde à pesquisa.} one {{count} sugestão disponível para texto digitado.} other {{count} sugestões disponíveis para texto digitado.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Enter',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Pesquisar',
  'fabric.editor.elementbrowser.sidebar.heading': 'Procurar',
  'fabric.editor.embedTitle': 'Integrar',
  'fabric.editor.embedToBlockCardWarning': 'Aparece como cartão em telas pequenas',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Use emojis para expressar ideias 🎉 e emoções 😄',
  'fabric.editor.emptyLink': 'Insira um link.',
  'fabric.editor.emptySearchResults': 'Não foi possível encontrar nenhum resultado.',
  'fabric.editor.emptySearchResultsSuggestion': 'Selecione {buttonName} para procurar inserções.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Erro',
  'fabric.editor.errorPanel': 'Painel de erros',
  'fabric.editor.errorPanel.description': 'Destacar erros em um painel colorido',
  'fabric.editor.expand': 'Expandir',
  'fabric.editor.expand.description': 'Inserir expansão',
  'fabric.editor.expandAriaLabel': 'Dê um título a essa expansão',
  'fabric.editor.expandDefaultTitle': 'Clique aqui para expandir...',
  'fabric.editor.expandNode': 'Expandir conteúdo',
  'fabric.editor.expandPlaceholder': 'Dê um título para a expansão...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'A exclusão de {nodeName} vai interromper qualquer coisa conectada a ela.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Exclusão',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Excluir',
  'fabric.editor.extension.deleteElementTitle': 'Excluir elemento',
  'fabric.editor.extension.sourceNoTitledName': 'este elemento',
  'fabric.editor.extensions.config-panel.save-indicator': 'Todas as alterações são salvas automaticamente',
  'fabric.editor.externalExtensionsHeading': 'Aplicativos',
  'fabric.editor.externalMediaFile': 'Arquivo de mídia externo',
  'fabric.editor.failed_to_upload': 'Falha ao carregar',
  'fabric.editor.feedbackDialog': 'Enviar feedback',
  'fabric.editor.feedbackDialog.description': 'Diga como foi sua experiência usando o editor de nuvem',
  'fabric.editor.find': 'Localizar',
  'fabric.editor.findNext': 'Localizar próxima',
  'fabric.editor.findPrevious': 'Localizar anterior',
  'fabric.editor.findReplaceToolbarButton': 'Localizar e substituir',
  'fabric.editor.fiveColumns': 'Layout de 5 colunas',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Cancelar',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Excluir também elementos conectados',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 elemento conectado)} other {{name} (+{amount,number} elementos conectados)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Tem certeza?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer':
    'Os controles da barra de ferramentas flutuante foram abertos',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Barra de ferramentas flutuante',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Opções de layout',
  'fabric.editor.floatingToolbar.scrollLeft': 'Rolar para a esquerda',
  'fabric.editor.floatingToolbar.scrollRight': 'Rolar para a direita',
  'fabric.editor.focusTableResizeHandle': 'Alça de redimensionamento da tabela Foco',
  'fabric.editor.fourColumns': 'Layout de 4 colunas',
  'fabric.editor.headerColumn': 'Coluna do cabeçalho',
  'fabric.editor.headerRow': 'Linha do cabeçalho',
  'fabric.editor.heading1': 'Título 1',
  'fabric.editor.heading1Description': 'Use isso para um título de nível superior',
  'fabric.editor.heading2': 'Título 2',
  'fabric.editor.heading2Description': 'Use isso para seções importantes',
  'fabric.editor.heading3': 'Título 3',
  'fabric.editor.heading3Description': 'Use isso para subseções e títulos de grupos',
  'fabric.editor.heading4': 'Título 4',
  'fabric.editor.heading4Description': 'Use isso para títulos profundos',
  'fabric.editor.heading5': 'Título 5',
  'fabric.editor.heading5Description': 'Use isso para agrupar os itens de uma lista',
  'fabric.editor.heading6': 'Título 6',
  'fabric.editor.heading6Description': 'Use isso para títulos de nível inferior',
  'fabric.editor.headingLink.ascOrderLabel': 'Ordenar coluna de Z a A',
  'fabric.editor.headingLink.descOrderLabel': 'Limpar classificação',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Bug',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Item',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Ticket',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Página',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'História',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Tarefa',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Você não pode ordenar uma tabela com células mescladas',
  'fabric.editor.headingLink.noOrderLabel': 'Ordenar coluna de A a Z',
  'fabric.editor.help': 'Ajuda',
  'fabric.editor.help.description': 'Procurar todos os atalhos de teclado e opções de markdown',
  'fabric.editor.helpDialogTips': 'Pressione {keyMap} para abrir rapidamente esta caixa de diálogo a qualquer momento',
  'fabric.editor.highlight': 'Cor de realce',
  'fabric.editor.highlight.removeColor': 'Remover cor',
  'fabric.editor.highlightColor': 'Alternar paleta de cores de destaque',
  'fabric.editor.highlightFloatingToolbar': 'Realce',
  'fabric.editor.horizontalRule': 'Divisória',
  'fabric.editor.horizontalRule.description': 'Separar conteúdo com uma linha horizontal',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Colar ou pesquisar link',
  'fabric.editor.hyperlink.searchLinkAriaDescription':
    'As sugestões vão aparecendo abaixo conforme você digita no campo',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {nenhum resultado encontrado} one {{count,number} resultado encontrado} other {{count,number} resultados encontrados}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Texto para exibição (opcional)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Colar ou pesquisar link',
  'fabric.editor.image': 'Imagem',
  'fabric.editor.image.fullWidthLabel': 'Largura total',
  'fabric.editor.imageBorderBold': 'Negrito',
  'fabric.editor.imageBorderColor': 'Cor',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Menu suspenso com opções de cores para a borda da imagem',
  'fabric.editor.imageBorderMedium': 'Média',
  'fabric.editor.imageBorderOptions': 'Opções da borda',
  'fabric.editor.imageBorderSize': 'Tamanho',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'Menu suspenso com opções de tamanhos para a borda da imagem',
  'fabric.editor.imageBorderSubtle': 'Sutil',
  'fabric.editor.improvement': 'Melhoria',
  'fabric.editor.increaseElementSize': 'Aumentar o tamanho do elemento',
  'fabric.editor.increaseSize': 'Aumentar tamanho da tabela ou imagem',
  'fabric.editor.indent': 'Recuo',
  'fabric.editor.info': 'Informações',
  'fabric.editor.infoPanel': 'Painel de informações',
  'fabric.editor.infoPanel.description': 'Destacar informações em um painel colorido',
  'fabric.editor.inlineConfigureLink': 'Configurar link',
  'fabric.editor.inlineDescription': 'Mostrar link como texto em linha',
  'fabric.editor.inlineGoToLink': 'Acessar link',
  'fabric.editor.inlineOverlay': 'Configurar',
  'fabric.editor.inlineTitle': 'Em linha',
  'fabric.editor.inputQueryAssistiveTxt':
    'Quando os resultados do preenchimento automático estiverem disponíveis, use as setas para cima e para baixo para analisar e a tecla enter para selecionar. Toque nos usuários do dispositivo, explore por toque ou com gestos de deslizar.',
  'fabric.editor.insertColumn': 'Inserir coluna à direita',
  'fabric.editor.insertColumnDrag': 'Inserir coluna',
  'fabric.editor.insertMenu': 'Inserir elementos',
  'fabric.editor.insertRightRail.close': 'Fechar',
  'fabric.editor.insertRightRail.title': 'Inserir',
  'fabric.editor.insertRow': 'Inserir linha abaixo',
  'fabric.editor.insertRowDrag': 'Inserir linha',
  'fabric.editor.insertTableColumn': 'Inserir coluna na tabela',
  'fabric.editor.insertTableRow': 'Inserir linha na tabela',
  'fabric.editor.invalidDateError': 'Informe uma data válida',
  'fabric.editor.invalidLink': 'Insira um link válido.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Convidar colega de equipe para {productName}} trusted {Convidar colega de equipe para {productName}} other {Adicionar colega de equipe para {productName}}}',
  'fabric.editor.italic': 'Itálico',
  'fabric.editor.keyboardShortcuts': 'Atalhos de teclado',
  'fabric.editor.layout.columnOption': '{count, plural, one {Coluna} other {{count} colunas}}',
  'fabric.editor.layout.controls.placeholder': '/ para inserir',
  'fabric.editor.layout.placeholder': 'Adicionar conteúdo',
  'fabric.editor.layout.resizeLayout': 'Redimensionar layout',
  'fabric.editor.layoutFixedWidth': 'Voltar ao centro',
  'fabric.editor.layoutFullWidth': 'Usar largura inteira',
  'fabric.editor.layoutStateFixedWidth': 'Centralizado',
  'fabric.editor.layoutStateFullWidth': 'Largura total',
  'fabric.editor.layoutStateWide': 'Largo',
  'fabric.editor.layoutWide': 'Ampliar',
  'fabric.editor.leftSidebar': 'Layout com barra lateral à esquerda',
  'fabric.editor.link': 'Link',
  'fabric.editor.link.description': 'Insira um link',
  'fabric.editor.linkAddress': 'Endereço do link',
  'fabric.editor.linkPlaceholder': 'Colar link',
  'fabric.editor.lists': 'Listas',
  'fabric.editor.listsFormat': 'Formatação da lista',
  'fabric.editor.lockColumns': 'Larguras fixas de coluna',
  'fabric.editor.longEmptyNodePlaceholderText': 'Digite / para inserir elementos',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Diferenciar maiúsculas de minúsculas',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Largura da mídia diminuída para {newMediaWidth,number} pixel.} other {Largura da mídia diminuída para {newMediaWidth,number} pixels.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Largura da mídia aumentada para {newMediaWidth,number} pixel.} other {Largura da mídia aumentada para {newMediaWidth,number} pixels.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Mídia diminuída para o tamanho máximo',
  'fabric.editor.media.insert.cancel': 'Cancelar',
  'fabric.editor.media.insert.fileTabTitle': 'Arquivo',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Não foi possível adicionar o link desta imagem. Faça download do arquivo, então arraste e solte a imagem na página.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Talvez esta imagem não fique visível para outras pessoas devido a restrições da fonte. Faça upload do arquivo.',
  'fabric.editor.media.insert.insert': 'Inserir',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Link inválido',
  'fabric.editor.media.insert.linkTabTitle': 'Link',
  'fabric.editor.media.insert.loadPreview': 'Carregar pré-visualização',
  'fabric.editor.media.insert.localFileErrorMessage': 'Não foi possível carregar o arquivo.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Erro ao carregar o arquivo. Verifique o caminho ou rede do arquivo.',
  'fabric.editor.media.insert.mediaAlt': 'Pré-visualização do arquivo de imagem ou vídeo enviado',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Seletor de mídia',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Cole o link para fazer upload',
  'fabric.editor.media.insert.upload': 'Carregar',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Mídia aumentada para o tamanho máximo',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Redimensionar',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Fechar',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'entrada de altura',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Altura',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Largura máxima {maxWidth} px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Largura',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Largura máxima {maxWidth} px',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Converter em pixels',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Migrar do percentual para o tamanho fixo de pixels',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Enviar',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Falha na validação da largura',
  'fabric.editor.mediaAddLink': 'Adicionar link',
  'fabric.editor.mediaFiles': 'Imagem, vídeo ou arquivo',
  'fabric.editor.mediaFiles.description': 'Adicionar imagens e outros arquivos à sua página',
  'fabric.editor.mediaGroupDeleteLabel': 'excluir',
  'fabric.editor.media_change_mediainline_caption_warn': 'Incorporada (a legenda vai ser removida)',
  'fabric.editor.media_change_mediainline_default': 'Em linha',
  'fabric.editor.media_change_mediasingle': 'Tamanho original',
  'fabric.editor.mention': 'Menção',
  'fabric.editor.mention.description': 'Mencione alguém para enviar uma notificação',
  'fabric.editor.mentionNode.label': 'Usuário marcado',
  'fabric.editor.mentionsAddLabel': 'ícone de adicionar',
  'fabric.editor.mentionsIconLabel': 'Mencionar',
  'fabric.editor.mergeCells': 'Mesclar células',
  'fabric.editor.moreFormatting': 'Mais formatação',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Mover coluna para a esquerda} other {Mover colunas para a esquerda}}',
  'fabric.editor.moveColumnRight':
    '{0, plural, one {Mover coluna para a direita} other {Mover colunas para a direita}}',
  'fabric.editor.moveDownDown': '{0, plural, one {Mover linha para baixo} other {Mover linhas para baixo}}',
  'fabric.editor.moveRowUp': '{0, plural, one {Mover linha para cima} other {Mover linhas para cima}}',
  'fabric.editor.navigate.toolbar.askAI': 'Perguntar à IA',
  'fabric.editor.navigate.toolbar.editor': 'Navegue até a barra de ferramentas do editor',
  'fabric.editor.navigate.toolbar.floating': 'Navegue até a barra de ferramentas flutuante',
  'fabric.editor.noPermissionToAddComment':
    '{contentType, select, blogpost {Você não tem permissão para adicionar comentários a este blog} page {Você não tem permissão para adicionar comentários a esta página} other {Você não tem permissão para adicionar comentários a esta página}}',
  'fabric.editor.noResultsFound': 'Sem resultados',
  'fabric.editor.noSearchResults': 'Nenhum resultado de pesquisa',
  'fabric.editor.normal': 'Texto normal',
  'fabric.editor.note': 'Observação',
  'fabric.editor.notePanel': 'Painel de notas',
  'fabric.editor.notePanel.description': 'Adicionar uma nota em um painel colorido',
  'fabric.editor.numberedColumn': 'Coluna numerada',
  'fabric.editor.off': '{formattingType} Desativado',
  'fabric.editor.on': '{formattingType} Ativado',
  'fabric.editor.openButtonTitle': 'Aberto',
  'fabric.editor.openCellOptions': 'Abrir opções de célula',
  'fabric.editor.openLink': 'Abrir link em uma nova guia',
  'fabric.editor.openPreviewPanel': 'Abrir painel de pré-visualização',
  'fabric.editor.orderedList': 'Lista numerada',
  'fabric.editor.orderedList.description': 'Criar uma lista ordenada',
  'fabric.editor.other': 'Outros...',
  'fabric.editor.outdent': 'Recuo para a esquerda',
  'fabric.editor.overflowMenuViewMore': 'Ver mais',
  'fabric.editor.pageActionsLabel': 'Ações de página',
  'fabric.editor.panel': 'Painel',
  'fabric.editor.panel.backgroundColor': 'Cor de fundo',
  'fabric.editor.panel.custom': 'Personalizado',
  'fabric.editor.panel.emoji': 'Adicionar emoji',
  'fabric.editor.panel.panelsGroup': 'Tipos de painel',
  'fabric.editor.panelButtonTitle': 'Painel',
  'fabric.editor.pasteOptions': 'Colar opções',
  'fabric.editor.pastePlainText': 'Colar texto sem formatação',
  'fabric.editor.placeholderAltText': 'Descrever esta imagem com texto alt',
  'fabric.editor.placeholderText': 'Texto do espaço reservado',
  'fabric.editor.placeholderText.description': 'Inserir um espaço reservado para texto na página',
  'fabric.editor.placeholderTextPlaceholder': 'Adicionar texto do espaço reservado',
  'fabric.editor.plainText': 'Usar texto simples',
  'fabric.editor.preferencesLink': 'Preferências de link',
  'fabric.editor.previewButtonTitle': 'Pré-visualizar',
  'fabric.editor.quickInsert': 'Inserção rápida',
  'fabric.editor.recordLoomShortTitle': 'Gravar',
  'fabric.editor.recordVideo': 'Gravar vídeo do Loom',
  'fabric.editor.recordVideo.description': 'Grave e compartilhe sua tela e suas ideias',
  'fabric.editor.redo': 'Refazer',
  'fabric.editor.remove': 'Remover',
  'fabric.editor.removeColumns': '{0, plural, one {Excluir coluna} other {Excluir colunas}}',
  'fabric.editor.removeEmoji': 'Remover emoji',
  'fabric.editor.removeImageBorder': 'Remover borda',
  'fabric.editor.removeRows': '{0, plural, one {Excluir linha} other {Excluir linhas}}',
  'fabric.editor.replace': 'Substituir',
  'fabric.editor.replaceAll': 'Substituir tudo',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {{numberOfMatches,number} correspondência substituída} other {{numberOfMatches,number} correspondências substituídas}}',
  'fabric.editor.replaceWith': 'Substituir por',
  'fabric.editor.requestToEdit': 'Solicitar permissão para editar',
  'fabric.editor.requestToEditDescription':
    'Ao solicitar acesso, o proprietário da página vai receber uma notificação.',
  'fabric.editor.requestToEditDismiss': 'Ignorar',
  'fabric.editor.resizeHandle': 'Redimensionar alça',
  'fabric.editor.resultsCount': '{selectedMatchPosition} de {totalResultsCount}',
  'fabric.editor.richText': 'Usar rich text',
  'fabric.editor.rightSidebar': 'Layout com barra lateral à direita',
  'fabric.editor.rowControl': 'Destacar linha',
  'fabric.editor.rowDragHandle': 'Opções de linhas',
  'fabric.editor.rowMovedDown': 'Linha movida para baixo para {index} de {total}',
  'fabric.editor.rowMovedUp': 'Linha movida para cima para {index} de {total}',
  'fabric.editor.rowSelected': 'Linha {index} de {total} selecionada',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Uma linha foi inserida} other {{count} linhas foram inseridas}}',
  'fabric.editor.rowsAreRemoved': '{count, plural, one {A linha foi removida} other {{count} linhas foram removidas}}',
  'fabric.editor.saveButton': 'Salvar',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {{itemsLength,number} resultado de pesquisa disponível. Use as setas Para cima e Para baixo para navegar entre as opções. Pressione Enter para selecionar uma opção.} other {{itemsLength,number} resultados de pesquisa disponíveis. Use as setas Para cima e Para baixo para navegar entre as opções. Pressione Enter para selecionar uma opção.}}',
  'fabric.editor.selectColumnResize': 'Selecionar redimensionamento de coluna',
  'fabric.editor.selectLanguage': 'Selecione a linguagem',
  'fabric.editor.selectTableColumn': 'Selecione a coluna da tabela',
  'fabric.editor.selectTableRow': 'Selecione a linha da tabela',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Selecionar app',
  'fabric.editor.selectionToolbarOverflowMenuTooltip': 'Mais opções',
  'fabric.editor.settingsLinks': 'Ir para Preferências do link',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ para inserir',
  'fabric.editor.shortcut': 'Atalho de texto',
  'fabric.editor.single': 'Layout com coluna única',
  'fabric.editor.singleColumns': 'Layout com 1 coluna',
  'fabric.editor.sortColumnASC': 'Ordenar coluna A → Z',
  'fabric.editor.sortColumnDESC': 'Ordenar coluna Z → A',
  'fabric.editor.sortColumnDecreasing': 'Ordem decrescente',
  'fabric.editor.sortColumnIncreasing': 'Ordem crescente',
  'fabric.editor.splitCell': 'Dividir célula',
  'fabric.editor.status': 'Status',
  'fabric.editor.status.description': 'Adicionar uma categoria de status personalizado',
  'fabric.editor.statusEditorLabel': 'Editor de status',
  'fabric.editor.statusPickerOpenedAlert': 'O pop-up do editor de status foi aberto, pressione Tab para acessar',
  'fabric.editor.statusPlaceholder': 'Definir status',
  'fabric.editor.story': 'História',
  'fabric.editor.strike': 'Tachado',
  'fabric.editor.subTask': 'Subtarefa',
  'fabric.editor.subscript': 'Subscrito',
  'fabric.editor.subscript.off.superscript.on': 'Subscrito desativado, sobrescrito ativado',
  'fabric.editor.success': 'Sucesso',
  'fabric.editor.successPanel': 'Painel de sucesso',
  'fabric.editor.successPanel.description': 'Adicionar dicas em um painel colorido',
  'fabric.editor.superscript': 'Sobrescrito',
  'fabric.editor.superscript.off.subscript.on': 'Sobrescrito desativado, subscrito ativado',
  'fabric.editor.supportAltText':
    'O texto alt ajuda pessoas que usam leitores de tela por conta de limitações visuais.',
  'fabric.editor.syncBlockGroup': 'Tipo de bloco de sincronização',
  'fabric.editor.syncedBlock': 'Bloco sincronizado',
  'fabric.editor.syncedBlock.description': 'Atualização automática do conteúdo nos apps da Atlassian',
  'fabric.editor.table': 'Tabela',
  'fabric.editor.table.description': 'Inserir uma tabela',
  'fabric.editor.tableAlignmentOptions': 'Opções de alinhamento',
  'fabric.editor.tableFullWidthLabel': 'Largura total',
  'fabric.editor.tableHeader.sorting.asc': 'Ordenação crescente aplicada',
  'fabric.editor.tableHeader.sorting.default': 'Ordenar coluna',
  'fabric.editor.tableHeader.sorting.desc': 'Ordenação decrescente aplicada',
  'fabric.editor.tableHeader.sorting.invalid': 'Não é possível ordenar uma tabela com células mescladas',
  'fabric.editor.tableHeader.sorting.no': 'Nenhuma ordenação aplicada à coluna',
  'fabric.editor.tableOptions': 'Opções de tabela',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {A largura da tabela foi reduzida para {newWidth,number} pixel.} other {A largura da tabela foi reduzida para {newWidth,number} pixels.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {A largura da tabela aumentou para {newWidth,number} pixel.} other {A largura da tabela aumentou para {newWidth,number} pixels.}}',
  'fabric.editor.tableScrollRegion': 'Área de rolagem da tabela',
  'fabric.editor.tableSelector': 'Tamanho da tabela',
  'fabric.editor.tableSelector.description': 'Adicionar tabela usando pop-up para selecionar um tamanho personalizado',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} por {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Seletor de tamanho da tabela',
  'fabric.editor.tables.adjustColumn': 'Ajustar coluna',
  'fabric.editor.tables.columnResizeLast': 'Você só pode redimensionar essa coluna para a esquerda.',
  'fabric.editor.tables.columnResizeOverflow':
    'Você só pode redimensionar essa coluna enquanto a tabela tiver uma barra de rolagem.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {A largura da coluna foi alterada para {width} pixel} other {A largura da coluna foi alterada para {width} pixels}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'A exclusão de {nodeName} vai interromper qualquer coisa conectada a ela.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Excluir',
  'fabric.editor.tables.resizeStop': 'Redimensionamento interrompido',
  'fabric.editor.tables.resizeTable': 'Redimensionar tabela',
  'fabric.editor.tables.startedColumnResize': 'Redimensionamento da coluna iniciado',
  'fabric.editor.task': 'Tarefa',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'Marcar a tarefa como concluída',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'Marcar a tarefa como não concluída',
  'fabric.editor.taskList': 'Lista de Tarefas',
  'fabric.editor.taskPlaceholder': 'Digite sua ação e use "@" para atribuí-la a alguém.',
  'fabric.editor.text.formatting.off': 'Formatação de texto desativada',
  'fabric.editor.textColor': 'Cor do texto {selectedColorName}',
  'fabric.editor.textColorHighlightTooltip': 'Cor do texto e de destaque',
  'fabric.editor.textColorTooltip': 'Cor do texto',
  'fabric.editor.textFormat': 'Formatar texto',
  'fabric.editor.textFormatting': 'Formatação de texto',
  'fabric.editor.textStyles': 'Estilos de texto {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Estilos de texto',
  'fabric.editor.threeColumns': 'Layout de 3 colunas',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Layout de três colunas com barra lateral à esquerda',
  'fabric.editor.threeColumnsWithRightSidebars': 'Layout de três colunas com barra lateral à direita',
  'fabric.editor.threeColumnsWithSidebars': 'Layout com três colunas com barras laterais',
  'fabric.editor.time.ago': 'atrás',
  'fabric.editor.time.updated': 'Atualizado',
  'fabric.editor.time.viewed': 'Visualizado',
  'fabric.editor.toolbarAppears': 'A barra de ferramentas aparece',
  'fabric.editor.toolbarLabel': 'Editor',
  'fabric.editor.toolbarMediaTitle': 'Adicionar imagem, vídeo ou arquivo',
  'fabric.editor.toolbarPositionFixedAtTop': 'Fixado na parte superior',
  'fabric.editor.toolbarPositionInline': 'Em linha com o texto',
  'fabric.editor.toolbarPositionPinedAtTop': 'Desafixar barra de ferramentas',
  'fabric.editor.toolbarPositionUnpined': 'Fixe a barra de ferramentas no topo',
  'fabric.editor.toolbarPositionUnpinnedConcise': 'Fixar barra de ferramentas no topo',
  'fabric.editor.tooltip.blockPanel': 'painel',
  'fabric.editor.tooltip.bulletList': 'lista',
  'fabric.editor.tooltip.decisionList': 'lista de decisões',
  'fabric.editor.tooltip.defaultBlockNode': 'ponto central de bloco',
  'fabric.editor.tooltip.nestedExpand': 'expansão aninhada',
  'fabric.editor.tooltip.taskList': 'item de ação',
  'fabric.editor.turnInto': 'Transformar em',
  'fabric.editor.twoColumns': 'Layout de 2 colunas',
  'fabric.editor.typeAhead.popupLabel': 'Resultados de digitação antecipada',
  'fabric.editor.typeAhead.quickInsertInputLabel': 'Comece a digitar para pesquisar ou filtrar as opções de atalho',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Pesquisar',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Atalhos para inserções e formatação',
  'fabric.editor.typeAheadErrorFallbackDescription': 'Nenhum resultado disponível. Tente outra vez.',
  'fabric.editor.typeAheadErrorFallbackHeading': 'Algo deu errado',
  'fabric.editor.typeahead.emojiInputLabel': 'Comece a digitar para pesquisar ou filtrar as opções de emoji',
  'fabric.editor.typeahead.emojiListItemLabel': 'Atalho de texto {shortcut} do emoji {name}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Atalhos de emojis',
  'fabric.editor.typeahead.mentionInputLabel': 'Comece a digitar para pesquisar usuários a serem marcados',
  'fabric.editor.typeahead.mentionPopupLabel': 'Usuários que você pode marcar',
  'fabric.editor.typeahead.metionListItemLabel': 'Usuário {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'Não foi possível carregar o conteúdo',
  'fabric.editor.unableToOpenLink': 'Não é possível abrir este link',
  'fabric.editor.underline': 'Sublinhado',
  'fabric.editor.undo': 'Desfazer',
  'fabric.editor.unknown.label': 'Desconhecido',
  'fabric.editor.unlink': 'Remover link',
  'fabric.editor.unorderedList': 'Lista de marcadores',
  'fabric.editor.unorderedList.description': 'Criar uma lista sem ordenação',
  'fabric.editor.unsupportedBlockContent': 'Este editor não é compatível com a exibição deste conteúdo',
  'fabric.editor.unsupportedContentTooltip':
    'O conteúdo não está disponível neste editor. Ele vai ser preservado quando você editar e salvar',
  'fabric.editor.unsupportedInlineContent': 'Conteúdo não compatível',
  'fabric.editor.upDown':
    'Ao usar as teclas de seta para cima e para baixo no seguinte campo de entrada, a data vai ser atualizada abaixo',
  'fabric.editor.url': 'Mostrar URL',
  'fabric.editor.urlDescription': 'Mostrar link como URL',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'Usar marcação',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Ver e adicionar comentários',
  'fabric.editor.viewCommentOnMedia': 'Visualizar comentários',
  'fabric.editor.viewMore': 'Ver mais',
  'fabric.editor.viewMoreAriaLabel': 'Exibir todos os elementos',
  'fabric.editor.visit': 'Abrir link em uma nova janela',
  'fabric.editor.warning': 'Aviso',
  'fabric.editor.warningPanel': 'Painel de avisos',
  'fabric.editor.warningPanel.description': 'Adicionar uma nota de atenção em um painel colorido',
  'fabric.editor.wrapLeft': 'Ajustar à esquerda',
  'fabric.editor.wrapRight': 'Ajustar à direita',
  'fabric.emoji.label': 'Emoji',
  'fabric.theme.blue': 'Blue',
  'fabric.theme.bold-blue': 'Azul forte',
  'fabric.theme.bold-gray': 'Cinza forte',
  'fabric.theme.bold-green': 'Verde forte',
  'fabric.theme.bold-magenta': 'Magenta forte',
  'fabric.theme.bold-orange': 'Laranja forte',
  'fabric.theme.bold-purple': 'Roxo forte',
  'fabric.theme.bold-red': 'Vermelho forte',
  'fabric.theme.bold-teal': 'Verde-azulado forte',
  'fabric.theme.bold-yellow': 'Amarelo forte',
  'fabric.theme.bolder-blue': 'Azul mais forte',
  'fabric.theme.bolder-gray': 'Cinza mais forte',
  'fabric.theme.bolder-green': 'Verde mais forte',
  'fabric.theme.bolder-magenta': 'Magenta mais forte',
  'fabric.theme.bolder-orange': 'Laranja mais forte',
  'fabric.theme.bolder-purple': 'Roxo mais forte',
  'fabric.theme.bolder-red': 'Vermelho mais forte',
  'fabric.theme.bolder-teal': 'Verde-azulado mais forte',
  'fabric.theme.bolder-yellow': 'Amarelo mais forte',
  'fabric.theme.dark-blue': 'Azul-escuro',
  'fabric.theme.dark-gray': 'Cinza-escuro',
  'fabric.theme.dark-green': 'Verde-escuro',
  'fabric.theme.dark-purple': 'Roxo-escuro',
  'fabric.theme.dark-red': 'Vermelho-escuro',
  'fabric.theme.dark-teal': 'Azul-petróleo-escuro',
  'fabric.theme.dark-yellow': 'Amarelo-escuro',
  'fabric.theme.default': 'Padrão',
  'fabric.theme.gray': 'Cinza',
  'fabric.theme.green': 'Verde',
  'fabric.theme.light-blue': 'Azul-claro',
  'fabric.theme.light-gray': 'Cinza-claro',
  'fabric.theme.light-green': 'Verde-claro',
  'fabric.theme.light-purple': 'Roxo-claro',
  'fabric.theme.light-red': 'Vermelho-claro',
  'fabric.theme.light-teal': 'Verde-petróleo claro',
  'fabric.theme.light-yellow': 'Amarelo-claro',
  'fabric.theme.lime': 'Lima',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'Sem destaques',
  'fabric.theme.orange': 'Laranja',
  'fabric.theme.purple': 'Roxo',
  'fabric.theme.red': 'Vermelho',
  'fabric.theme.subtle-blue': 'Azul fraco',
  'fabric.theme.subtle-gray': 'Cinza fraco',
  'fabric.theme.subtle-green': 'Verde fraco',
  'fabric.theme.subtle-magenta': 'Magenta fraco',
  'fabric.theme.subtle-orange': 'Laranja fraco',
  'fabric.theme.subtle-purple': 'Roxo fraco',
  'fabric.theme.subtle-red': 'Vermelho fraco',
  'fabric.theme.subtle-teal': 'Verde-azulado fraco',
  'fabric.theme.subtle-yellow': 'Amarelo fraco',
  'fabric.theme.teal': 'Azul-petróleo',
  'fabric.theme.white': 'Branco',
  'fabric.theme.yellow': 'Amarelo',
  'fabrid.editor.rowNumbers': 'Números das linhas',
  'rovo.agents.dropdown.title': 'Agentes',
  'rovo.agents.dropdown.viewAgents.label': 'Visualizar todos os agentes',
};
